import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  selectedAthletes: {},
  noAthletePicks: {},
  isSelectedAthletesLoading: true,
}

// getters
export const getters = {
  getSelectedAthletesForRound: ({ selectedAthletes }) => (roundId) => { return selectedAthletes[roundId] || [] },
  getIsNoAthletePickForRound: ({ noAthletePicks }) => (roundId) => { return noAthletePicks[roundId] || 0 },
  getCountOfSelectedAthletesForRound: (state, getters) => (roundId) => getters.getSelectedAthletesForRound(roundId).length,
}
// mutations
export const mutations = {
  fetchSelectedAthletesStart(state) {
    state.isSelectedAthletesLoading = true
  },
  fetchSelectedAthletesSuccess(state, { roundId, selectedAthletes }) {
    const athletes = selectedAthletes.athletes
      .map(({ pivot, ...rest }) => processAthlete(rest))
      .sort(({ round_score: scoreA }, { round_score: scoreB }) => {
        if (scoreB < scoreA) { return -1 }
        if (scoreB > scoreA) { return 1 }
        return 0
      })

    Vue.set(state.selectedAthletes, roundId, athletes)
    Vue.set(state.noAthletePicks, roundId, selectedAthletes.no_athlete)
    state.isSelectedAthletesLoading = false
  },
  fetchSelectedAthletesFailed(state) {
    state.isSelectedAthletesLoading = false
  },
}
// actions
export const actions = {
  async fetchSelectedAthletes({ commit, dispatch }, { roundId }) {
    let selectedAthletes = null
    try {
      commit('fetchSelectedAthletesStart')
      selectedAthletes = await axios.get(`prediction/${roundId}`)
      commit('fetchSelectedAthletesSuccess', { roundId, selectedAthletes })
    } catch (e) {
      commit('fetchSelectedAthletesFailed')
    }
    return selectedAthletes
  },
}
